import React from "react";
import Icon from "@mdi/react";
import { mdiChevronRight } from "@mdi/js";
import { currencyDisplay } from "../../../utils/helpers";

interface PromoBannerV3Props {
  priceCurrency?: string;
  /** Promo price entry (from tour.prices), if any */
  promoPrice?: { display_price?: string; adult?: number | string } | null;
  /** Normal (non-promo) price entry (from tour.prices), if any */
  normalPrice?: { display_price?: string; adult?: number | string } | null;
  /** Base/normal price as a display string, if any */
  basePrice?: string | null;
  onClick?: () => void;
}

/**
 * Price banner shown on V3 mobile screens.
 * - Promo price available  → "{pax range} Promo starts from {price}"
 * - Only a normal price    → "{pax range} starts from {price}"
 * - No price at all (rare) → renders nothing
 */
const PromoBannerV3: React.FC<PromoBannerV3Props> = ({
  priceCurrency,
  promoPrice,
  normalPrice,
  basePrice,
  onClick,
}) => {
  // Hide only when there is no price information at all.
  if (!promoPrice && !normalPrice && !basePrice) return null;
  return (
    <div className="promo-banner" onClick={onClick}>
      <div className="promo-banner_icon">
        <svg width="24" height="24" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M20.3212 9.45331C21.0412 8.53156 21.204 7.33606 20.7562 6.25531C20.3085 5.17456 19.3477 4.44406 18.1867 4.30156C17.4097 4.20631 16.7992 3.59656 16.7032 2.81806C16.5607 1.65706 15.8302 0.696311 14.7495 0.249311C13.6695 -0.198439 12.4732 -0.036439 11.5515 0.684311C10.9335 1.16656 10.0717 1.16656 9.45373 0.684311C8.53198 -0.0356889 7.33573 -0.199189 6.25573 0.249311C5.17498 0.697061 4.44448 1.65706 4.30198 2.81806C4.20598 3.59581 3.59623 4.20631 2.81848 4.30156C1.65748 4.44406 0.696731 5.17531 0.248981 6.25531C-0.198769 7.33531 -0.036019 8.53156 0.683981 9.45331C1.16623 10.0713 1.16623 10.9338 0.683981 11.5511C-0.036019 12.4728 -0.198769 13.6683 0.248981 14.7491C0.696731 15.8298 1.65748 16.5603 2.81848 16.7028C3.59548 16.7981 4.20598 17.4078 4.30198 18.1863C4.44448 19.3473 5.17498 20.3081 6.25573 20.7551C6.65848 20.9223 7.07698 21.0041 7.49173 21.0041C8.18923 21.0041 8.87548 20.7716 9.45298 20.3201C10.071 19.8378 10.9327 19.8378 11.5507 20.3201C12.4725 21.0393 13.6672 21.2028 14.7487 20.7551C15.8302 20.3073 16.56 19.3473 16.7025 18.1863C16.7985 17.4086 17.4082 16.7981 18.186 16.7028C19.347 16.5603 20.3077 15.8291 20.7555 14.7491C21.2032 13.6691 21.0405 12.4728 20.3205 11.5511C19.8382 10.9331 19.839 10.0706 20.3212 9.45331ZM12.003 13.5018C12.003 12.6746 12.6757 12.0018 13.503 12.0018C14.3302 12.0018 15.003 12.6746 15.003 13.5018C15.003 14.3291 14.3302 15.0018 13.503 15.0018C12.6757 15.0018 12.003 14.3291 12.003 13.5018ZM14.7832 7.28206L7.28323 14.7821C7.13698 14.9283 6.94498 15.0018 6.75298 15.0018C6.56098 15.0018 6.36898 14.9283 6.22273 14.7821C5.92948 14.4888 5.92948 14.0148 6.22273 13.7216L13.7227 6.22156C14.016 5.92831 14.49 5.92831 14.7832 6.22156C15.0765 6.51481 15.0765 6.98881 14.7832 7.28206ZM9.00298 7.50181C9.00298 8.32906 8.33023 9.00181 7.50298 9.00181C6.67573 9.00181 6.00298 8.32906 6.00298 7.50181C6.00298 6.67456 6.67573 6.00181 7.50298 6.00181C8.33023 6.00181 9.00298 6.67456 9.00298 7.50181Z" fill="url(#v3promo-badge)"/>
          <defs>
            <radialGradient id="v3promo-badge" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(-0.497068 -0.498291) rotate(41.6891) scale(42.8515 42.8538)">
              <stop stopColor="#FD8E3E"/>
              <stop offset="0.549569" stopColor="#FB7C28"/>
              <stop offset="1" stopColor="#F59678"/>
            </radialGradient>
          </defs>
        </svg>
      </div>
      {promoPrice ? (
        <span>{promoPrice.display_price} Promo starts from <strong>{currencyDisplay(priceCurrency, promoPrice.adult)}</strong></span>
      ) : normalPrice ? (
        <span>{normalPrice.display_price} starts from <strong>{currencyDisplay(priceCurrency, normalPrice.adult)}</strong></span>
      ) : (
        <span>View Price Details</span>
      )}
      <Icon path={mdiChevronRight} size="24px" color="#1E1E1E" />
    </div>
  );
};

export default PromoBannerV3;
